import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: "",
  hidden: ""
}, "Select Invoice Type...", -1)
const _hoisted_3 = ["value"]

import { JournalingType} from '@/models/Journaling/JournalingTypes';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoiceTypeSelector',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any) {

const invoiceTypes: JournalingType[] = [
    new JournalingType("CAR_SALE_INVOICE", "CarSaleInvoice", "Car Sale Invoice", "Car Sale Invoice"),
    new JournalingType("COLLECTIVE_CAR_SALE_INVOICE", "CollectiveCarSaleInvoice", "Collective Car Sale Invoice", "Collective Car Sale Invoice"),
    new JournalingType("RECHARGE_INVOICE", "RechargeInvoice", "Recharge Invoice", "Recharge Invoice"),
    new JournalingType("SERVICE_INVOICE", "ServiceInvoice", "Service Invoice", "Service Invoice"),
    new JournalingType("CUSTOMER_INVOICE", "CustomerInvoice", "Customer Invoice", "Customer Invoice"),
    new JournalingType("CUSTOMER_CREDIT_NOTE", "CustomerCreditNote", "Customer Credit Note", "Customer Credit Note"),
    new JournalingType("CAR_SALE_CREDIT_NOTE", "CarSaleCreditNote", "Car Sale Credit Note", "Car Sale Credit Note"),
    new JournalingType("REMARKETING_INVOICE", "RemarketingInvoice", "Remarketing Invoice", "Remarketing Invoice"),
	new JournalingType("REMARKETING_CREDIT_NOTE", "RemarketingCreditNote", "Remarketing Credit Note", "Remarketing Credit Note"),
    new JournalingType("FINAL_SETTLEMENT_INVOICE", "FinalSettlementInvoice", "Final Settlement Invoice", "Final Settlement Invoice"),
    new JournalingType("COLLECTIVE_FINAL_SETTLEMENT_INVOICE", "CollectiveFinalSettlementInvoice", "Collective Final Settlement Invoice", "Collective Final Settlement Invoice")
];



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("select", {
    value: _ctx.modelValue,
    onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', ($event?.target as HTMLInputElement)?.value)))
  }, [
    _hoisted_2,
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(invoiceTypes, (jType) => {
      return _createElementVNode("option", {
        value: jType.Canonical,
        key: jType.Canonical
      }, _toDisplayString(jType.DisplayShort), 9, _hoisted_3)
    }), 64))
  ], 40, _hoisted_1))
}
}

})